import { render } from "./Question.vue?vue&type=template&id=1cf478bb"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"

import exportComponent from "E:\\server\\www\\kpowa-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__